import { render, staticRenderFns } from "./new.participant-role.page.vue?vue&type=template&id=6fe94002&"
import script from "./new.participant-role.page.vue?vue&type=script&lang=js&"
export * from "./new.participant-role.page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports